// Global toast notifications — visible regardless of scroll position.
// Any code can fire `toast("ok" | "err", text)`; ToastHost (mounted once in
// App.tsx) renders them fixed at the bottom-right and auto-dismisses them.

export type ToastType = "ok" | "err";

export interface ToastItem {
  id: number;
  type: ToastType;
  text: string;
}

type Listener = (t: ToastItem) => void;

let seq = 0;
const listeners = new Set<Listener>();

export function toast(type: ToastType, text: string): void {
  const item: ToastItem = { id: ++seq, type, text };
  listeners.forEach((l) => l(item));
}

export function toastOk(text: string): void {
  toast("ok", text);
}

export function toastErr(text: string): void {
  toast("err", text);
}

export function onToast(l: Listener): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}
